import { AddressesView } from '../views/Addresses/addresses.view';
import { ChangeAddressView } from '../views/ChangeAddress/changeAddress.view';
import { ChooseFavoriteAddressView } from '../views/ChooseFavoriteAddress/chooseFavoriteAddress.view';
import { EditAddressView } from '../views/EditAddress/editAddress.view';
import { CreateOrEditAddressView } from '../views/CreateOrEditAddress/createOrEditAddress.view';
import { RouteType, type } from './Router';
import { Routes } from './types';
import { EditAddressNotes } from '../views/EditAddressNotes/editAddressNotes.view';
import { EditDoorbellPosition } from '../views/EditDoorbellPosition/editDoorbellPosition.view';

export const addressRoutes: RouteType[] = [
  {
    id: 'change-address',
    path: Routes.ChangeAddress,
    titleKey: 'pageTitles.changeAddress',
    type: type.PUBLIC,
    component: ChangeAddressView,
  },
  {
    id: 'create-address',
    path: Routes.CreateAddress,
    titleKey: 'pageTitles.newAddress',
    type: type.PUBLIC,
    component: CreateOrEditAddressView,
  },
  {
    id: 'edit-address',
    path: Routes.EditAddress,
    titleKey: 'pageTitles.editAddress',
    type: type.SECURED,
    component: EditAddressView,
  },
  {
    id: 'edit-order-address-notes',
    path: Routes.EditAddressNotes,
    titleKey: 'pageTitles.editAddressNotes',
    type: type.SECURED,
    component: EditAddressNotes,
  },
  {
    id: 'edit-order-address-doorbell-position',
    path: Routes.EditAddressDoorbellPosition,
    titleKey: 'pageTitles.editDoorbellPosition',
    type: type.SECURED,
    component: EditDoorbellPosition,
  },
  {
    id: 'choose-favorite-address',
    path: Routes.ChooseFavoriteAddress,
    titleKey: 'pageTitles.addresses',
    type: type.SECURED,
    component: ChooseFavoriteAddressView,
  },
  {
    id: 'address-list',
    path: Routes.Addresses,
    titleKey: 'pageTitles.addresses',
    type: type.SECURED,
    component: AddressesView,
  },
];
